import axios from 'axios';

// API para PictogramLayerStatus

/**
 * Crea un PictogramLayerStatus (sirve para type 'status', 'group' o 'incident').
 * El payload incluye el discriminador `type`.
 * Respuesta: { success, status } — el status completo con permissions (fase 1 backend).
 */
export function addLayerStatus(layerId, payload) {
  return axios.post('/api/v2/pictogram-layer/' + layerId + '/statuses', payload);
}

/**
 * Edita un PictogramLayerStatus existente. Mismo shape de respuesta que addLayerStatus.
 */
export function editLayerStatus(layerId, statusId, payload) {
  return axios.post('/api/v2/pictogram-layer/' + layerId + '/statuses/' + statusId, payload);
}

/**
 * Vincula un status a un grupo (cambia su parent_id).
 * Payload típico: { group_id: <id> }. Respuesta con echo del status.
 */
export function linkLayerStatus(layerId, statusId, payload) {
  return axios.post('/api/v2/pictogram-layer/' + layerId + '/statuses/' + statusId + '/link', payload);
}

export function deleteLayerStatus(layerId, statusId) {
  return axios.delete('/api/v2/pictogram-layer/' + layerId + '/statuses/' + statusId);
}

export async function fetchPictogramLayerStatuses(layerId, params = {}) {
  const url = `/api/v2/pictogram-layer/${layerId}/statuses`;
  return axios.get(url, { params: params });
}
